import { Box, Tooltip, Typography } from "@mui/material";
import { FLAGS_MAP } from "../flags";
import { getColor } from "../utils";
import { Calendar } from "lucide-react";

export default ({
  flags,
  flagUntilDate,
}: {
  flags: string[];
  flagUntilDate?: string;
}) => {
  if (!flags.length) return null;

  const isActive = flagUntilDate
    ? new Date(flagUntilDate) >= new Date()
    : false;
  const formattedDate = flagUntilDate
    ? new Date(flagUntilDate).toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      })
    : null;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: "8px",
      }}
    >
      {flags.map((flag) => {
        const flagObj = FLAGS_MAP[flag];
        if (!flagObj) return null;
        return (
          <Box
            key={flag}
            sx={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "#F0F0F0",
              padding: "4px 8px",
              borderRadius: "16px",
            }}
          >
            <Tooltip title={flagObj.title}>
              {flagObj.icon && (
                <flagObj.icon
                  size={16}
                  color={getColor(flagObj.activeStatus)}
                />
              )}
            </Tooltip>
          </Box>
        );
      })}
      {formattedDate && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "4px",
            backgroundColor: isActive ? "#FFF4E6" : "#F0F0F0",
            padding: "4px 8px",
            borderRadius: "16px",
            border: isActive ? "1.5px solid #FF9800" : "none",
          }}
        >
          <Calendar size={14} color={isActive ? "#FF9800" : "#6B6E7B"} />
          <Typography
            sx={{
              fontSize: "12px",
              fontWeight: isActive ? 600 : 400,
              color: isActive ? "#FF9800" : "#6B6E7B",
            }}
          >
            {isActive ? `Until ${formattedDate}` : `Expired ${formattedDate}`}
          </Typography>
        </Box>
      )}
    </Box>
  );
};
